import { ObjectMapper } from "json-object-mapper";
import { BenefitDiscountType } from "services/enums/benefitDiscountType.enum";
import { BenefitPricingType } from "services/enums/benefitPricingType.enum";
import { IModel } from "../../IModel";
import { Model } from "../../model";

export class BenefitPlanModel
	extends Model
	implements IModel<BenefitPlanModel> {
	benefitId: string = "";
	condition: number = 0;
	code: string = "";
	integrationCode: string = "";
	lineDescription: string = "";
	value: number = 0;
	holderDiscount: number = 0;
	dependentDiscount: number = 0;
	aggregateDiscount: number = 0;
	benefitDescription: string = "";
	detailsFile: string = "";
	holderValue: number = 0;
	dependentValue: number = 0;
	aggregateValue: number = 0;
	pricingType: BenefitPricingType = "UNSET";
	discountType: BenefitDiscountType = "PERCENTAGEM";
	forDependents: boolean = false;

	get benefitDescriptionBadge(): string {
		return `<span class="badge badge-light-primary text-wrap">${this.benefitDescription}</span>`;
	}

	static create(input: any): BenefitPlanModel {
		return ObjectMapper.deserialize<BenefitPlanModel>(BenefitPlanModel, input);
	}

	public toJSON(): string {
		return ObjectMapper.serialize(this) as string;
	}
}
